<template>
  <div class="resident-warpper">
    <div class="bg-white">
      <div class="flex align-center justify-between">
        <div class="flex align-center justify-between">
          <div class="flex align-center margin-right-sm ">
            <span>类型名称：</span>
            <el-input v-model="keyword" placeholder="请输入类型名称" class="flex-sub"></el-input>
          </div>
          <el-button type="primary" @click="hanldSearch">搜索</el-button>
        </div>
       <el-button type="primary" @click="setType('','')">添加类型</el-button>
      </div>

      <div class="flex align-center justify-between margin-tb-sm">
        <div>
          共{{ total }}条数据
        </div>
        <div>
        </div>
      </div>

      <el-table
        :data="list"
        header-row-class-name="table-header"
        row-class-name="table-row"
        alig="center"
        border
        style="width: 100%"
      >
        <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
        <el-table-column label="类型名称" prop="name"></el-table-column>
        <el-table-column label="添加时间" prop="create_time" width="220"></el-table-column>

        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <div class="table-operate" v-if="!scope.row.desc">
              <el-button
                size="small"
                type="primary"
                @click="setType(scope.row.id,scope.row.name)"
              >编辑
              </el-button>
              <el-button
                size="small"
                type="primary"
                @click="delItem(scope.row.id)"
              >删除
              </el-button>
            </div>

          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="list.length > 0"
        class="page-all"
        background
        @current-change="getList"
        :current-page.sync="page"
        :page-size="limit"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>

import {delQuestionCate, questionCateList, updateQuestionCate} from "@/api/study";

export default {
  name: "questions-type",
  data() {
    return {
      keyword:'',
      page: 1,
      limit: 10,
      total: 0,
      list:[],
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  created() {
    this.$emit("setIndex", this.$route.path, "双暖为老 / 试题类型", false);
    this.getList()
  },
  components: {},
  methods: {
    //  搜索
    hanldSearch(){
      this.page = 1
      this.getList()
    },
    //  获取列表
    async getList(){
      const res = await questionCateList(this.keyword,this.page,this.limit)
      this.list = res.data
      this.total = res.total_number
    },
    //  添加修改类型
    setType(id,str){
      this.$prompt('', '类型设置', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue:str,
        inputPlaceholder:'请输入类型名称'
      }).then(({ value }) => {
        if(!value) return this.$message.error('请输入类型名称')
        this.editType(id,value)
      })
    },
    async editType(id,val){
      const state = await updateQuestionCate(val,id)
      if(state.status === 200 ){
        this.getList()
        this.$message.success('操作成功！')
      } else{
        this.$message.erro(state.info)
      }
    },
    //  删除类型
    delItem(id) {
      this.$confirm('您确定要删除该类型吗？', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDel(id);
      });
    },
    async sureDel(id) {
      let _state = await delQuestionCate(id);
      if (this.list.length === 1 && this.page > 1) {
        this.page--;
      }
      this.getList()
      this.$message.success(_state.info);
    },
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
